import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { NavLink } from 'react-router'

import { Icon } from '../../shared/components'

import type { NavGroupProps } from './Shell.types'

/**
 * A menu section as an accordion panel (WAI-ARIA disclosure): the header
 * button folds the links away. The section with the current page stays
 * open; in the icon rail every link is shown and labels become tooltips.
 */
export function NavGroup({
  section,
  open,
  active,
  rail,
  onToggle,
}: NavGroupProps) {
  const expanded = rail || open || active
  const panel = `nav-section-${section.id.replace(/[^a-z0-9-]/gi, '-')}`

  return (
    <div className="sidebar__section" data-open={expanded || undefined}>
      <button
        type="button"
        className="sidebar__group"
        aria-expanded={expanded}
        aria-controls={panel}
        title={rail ? section.title : undefined}
        disabled={rail}
        onClick={onToggle}
      >
        {section.icon && (
          <Icon icon={section.icon} className="sidebar__group-icon" />
        )}
        <span className="sidebar__label">{section.title}</span>
        {!rail && (
          <>
            {!expanded && (
              <span className="sidebar__count" aria-hidden>
                {section.items.length}
              </span>
            )}
            <Icon icon={faChevronRight} className="sidebar__chevron" />
          </>
        )}
      </button>
      <div className="sidebar__panel" id={panel} inert={!expanded}>
        <div className="sidebar__panel-inner">
          {section.items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className="nav-link"
              title={rail ? item.label : undefined}
            >
              <Icon icon={item.icon} />
              <span className="sidebar__label">{item.label}</span>
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  )
}
